import { IUserGraph } from "@/models";
import { IXtrtUserRole } from "@/models/xtrt";
import { BaseRepository } from "@/repositories";

class XtrtValidatorRepository extends BaseRepository<IXtrtUserRole> {
    protected getAllErrorMessage = "Validators cannot be retrieved.";

    protected getOneErrorMessage = "This Validator cannot be retrieved.";

    protected addErrorMessage = "This Validator cannot be created, please verify fields.";

    protected updateErrorMessage = "This Validator cannot be updated, please verify fields.";

    protected removeErrorMessage = "This Validator cannot be removed.";

    constructor() {
        super("/xtrt/validators");
    }

    async importValidators(validatorsFile: File): Promise<IXtrtUserRole[]> {
        const formData = new FormData();
        formData.append("validatorsFile", validatorsFile);

        return await this.put("/import", formData, "multipart/form-data");
    }

    async setValidators(entityId: number | null, users: IUserGraph[]): Promise<IXtrtUserRole[]> {
        return await this.put("/", {
            entityId,
            users,
        });
    }
}

const xtrtValidatorRepository = new XtrtValidatorRepository();

export { XtrtValidatorRepository, xtrtValidatorRepository };
